import React, { useState, useEffect } from "react";
import { View } from "react-native";
import DisputeHome from "./DisputeHome";
import DisputeStatements from "./DisputeStatements";
import CreateRaiseDispute from "./CreateRaiseDispute";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  minSize,
  maxSize,
  useDeviceSize,
} from "rn-responsive-styles";
import Header from "../../common/Header";
import Sidebar from "../../common/Sidebar";
import MobileHeader from "../../common/MobileHeader";
import TabHeader from "../../common/TabHeader";
export default function Index(props) {
  console.log(props.selectedItem, "props kjkjjk");
  const styles = useStyles();
  const [isShowSidebar, setIsShowSidebar] = useState(false);
  const [activeScreen, setActiveScreen] = useState("home");
  const [data, setData] = useState({});

  useEffect(() => {
    if (props?.selectedItem != "") {
      setActiveScreen(props?.selectedItem);
    }
  }, [props?.selectedItem]);

  function renderSwitch() {
    switch (activeScreen) {
      case "home":
        return (
          <DisputeHome
            navigation={props.navigation}
            setScreen={setActiveScreen}
            setData={setData}
            data={data}
          />
        );
      case "DisputeTransactions":
        return (
          <DisputeStatements
            navigation={props.navigation}
            setScreen={setActiveScreen}
            setData={setData}
            data={data}
            info={{
              backNavigation: "home",
            }}
          />
        );
      case "CreateDispute":
        return (
          <CreateRaiseDispute
            navigation={props.navigation}
            setScreen={setActiveScreen}
            setData={setData}
            data={data}
            info={{
              backNavigation: "DisputeTransactions",
            }}
          />
        );

      default:
        return (
          <DisputeHome
            navigation={props.navigation}
            setScreen={setActiveScreen}
            setData={setData}
            data={data}
          />
        );
    }
  }

  return (
    // <>
    <View>
      <Header />
      <MobileHeader isShowSidebar={setIsShowSidebar}/>
      <TabHeader />
      <View style={styles.mainContainer}>
        <View style={styles.contentWidget}>
          {!isShowSidebar && <Sidebar navigation={props.navigation} />}
          <View style={{width:'100%',marginTop:-15}}>{renderSwitch()}</View>
        </View>
      </View>
    </View>

    // </>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    mainContainer: {
      width: "100%",
      height: "100vh",
      flexDirection: "row",
      justifyContent: "center",
    //   paddingTop: 40,
      backgroundColor: "#f2f4f5",
      backgroundImage:
        "linear-gradient(to top, #f2f4f5, #f2f4f5 50%, #eee 50%, #333 50%);",
    },
    contentWidget: {
      maxWidth: 1200,
      width: "100%",
      flexDirection: "row",
      marginTop:40
    },
    imageWidget: {
      width: "100%",
      height: "100%",
      borderRadius: 12,
      backgroundColor: "#f6f8f9",
      alignItems: "center",
      justifyContent: "center",
      marginLeft: 20,
    },
  },

  {
    [maxSize(DEVICE_SIZES.SM)]: {
      InfoBarLogo: {
        width: 150.7,
        height: 56.8,
      },
    },
    [maxSize(DEVICE_SIZES.XS)]: {
      mainContainer: {
        paddingTop: 20,
      },
      contentWidget: {
        width: "90%",
        marginLeft: -20,
      },
    },

    [maxSize(DEVICE_SIZES.MD)]: {
      container: { paddingLeft: 30 },
      contentWidget: {
        maxWidth: 999,
      },
      imageWidget: { width: "75%" },
      paymentMethodInfoBar: { marginTop: 0 },
    },

    [minSize(DEVICE_SIZES.LG)]: {
      paymentMethodInfoBar: {
        flexDirection: "row",
      },
    },
  }
);
